export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11265.7c91d1c1.jpg";